type verifyVendorsUsersType = {
  organizationId: string
  membershipId: string | undefined
}

const BFC_ORGANIZATION = '6966036a-12d4-4a57-a2ad-c119d797edd1'
const VENDORS_MEMBERSHIP = '8cb649bf-3bba-45d6-90e8-7db69975669b'

export const verifyVendorUserForBCF = ({
  organizationId,
  membershipId,
}: verifyVendorsUsersType) => {
  if (
    organizationId === BFC_ORGANIZATION &&
    membershipId === VENDORS_MEMBERSHIP
  ) {
    return true
  }

  return false
}
